<div class="wrapper_mng_emp marign_10">
    <fieldset class="scheduler-border">
        <legend class="scheduler-border"> Employee Searching Criteria</legend>
        <form novalidate="" name="InvoiceSearch" class="ng-pristine ng-valid ng-valid-required ">
            <div class="container_pad">
                <div class="row">
                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 margin_7">
                        <div class="row">
                            <div class="col-12 col-sm-3 col-md-3 col-lg-3 employee_sum_col">
                                <div class="form-group has-feedback">
                                    <label for="fName" class="control-label">First Name:</label>

                                    <input class="form-control" id="firstName" name="firstName" placeholder="First Name" minlength="2" maxlength="25" [(ngModel)]="employeeSearchCriteria.FirstName" #fastName="ngModel" [ngModelOptions]="{standalone: true}">

                                </div>
                            </div>
                            <div class="col-12 col-sm-3 col-md-3 col-lg-3 employee_sum_col">
                                <div class="form-group has-feedback">
                                    <label for="lastName" class="control-label">Last Name:</label>
                                    <input class="form-control" id="lastName" name="lastName" placeholder="Last Name" minlength="2" maxlength="25" [(ngModel)]="employeeSearchCriteria.LastName" #lastName="ngModel" [ngModelOptions]="{standalone: true}">

                                </div>
                            </div>
                            <div class="col-12 col-sm-3 col-md-3 col-lg-3 employee_sum_col">
                                <div class="form-group">
                                    <label class="control-label" for="email">Email:</label>
                                    <input type="email" placeholder="Email" name="email" id="email" class="form-control" pattern="[a-zA-Z0-9]\.?([a-zA-Z0-9._%+-])+@[a-z0-9.-]+\.[a-z]{2,4}$" [(ngModel)]="employeeSearchCriteria.Email" [ngModelOptions]="{standalone: true}" #email="ngModel">
                                    <div *ngIf="email.errors?.pattern" class="error">Email must be a valid email address</div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-3 col-md-3 col-lg-3 employee_sum_col">
                                <div class="form-group">
                                    <label for="userType" class="control-label">User Type:</label>
                                    <select type="text" class="form-control" [(ngModel)]="employeeSearchCriteria.UserType" id="userType" name="userType">
                                        <!-- <option value="" style="display: none">--- Select user type ---</option> -->
                                        <option value="Admin">Admin</option>
                                        <option value="Driver">Driver</option>
                                        <option value="Employee">Employee</option>
                                    </select>
                                </div>
                            </div>



                        </div>
                    </div>

                    <div class="col-12 col-sm-2 col-md-2 col-lg-2">
                        <div class="form-group employee_sum_top">
                            <div class="pull-right ">
                                <button type="submit" class="btn btn-primary" (click)="employeeSearch(1)">Search</button>
                                <button type="submit" class="btn btn-default" (click)="clear()">Clear</button>

                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </form>
    </fieldset>
    <fieldset class="scheduler-border operational_legend marign_10">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 pr-0">
            <div class="form-group employee_sum_top">
                <div class="pull-right margin_right10">
                    <div class="operational_legend ">
                        <a class="btn btn-primary pull-right margin_botm_5" (click)="AddEmployee()">Add Employee</a>
                    </div>


                </div>
            </div>
        </div>
        <legend class="scheduler-border">Employees List</legend>

        <div class="panel_table">
            <!-- <a class="btn btn-primary pull-right" (click)="AddEmployee()">Add Employee</a> -->

            <div class="panel panel-default ">
                <div class="table-responsive pull-left max-width margin-top-10">
                    <table class="table table-employee marign_10">
                        <thead class="tableHeader">
                            <tr>
                                <th>Name </th>
                                <th>Email </th>
                                <th>User Type </th>
                                <th>User Name </th>
                                <th>Action </th>
                            </tr>
                        </thead>
                        <tbody>

                            <tbody *ngIf="employeeList">
                                <tr *ngFor="let mod of employeeList">

                                    <td>{{mod.FullName}}</td>
                                    <td>{{mod.Email}}</td>
                                    <td>{{mod.UserType}}</td>
                                    <td>{{mod.UserName}}</td>
                                    <td>

                                        <span class="edit_employee"><i class="fa fa-2x fa-pencil-square-o"
                                            (click)="getEmployeeUpdate(mod.ID)"></i></span>
                                    </td>



                                </tr>
                            </tbody>
                    </table>
                    <div *ngIf="collectionSize > 10" style="float: right;">
                        <ngb-pagination [(page)]="employeeSearchCriteria.PageNo" [maxSize]="10" [collectionSize]="collectionSize" [ellipses]="true" [boundaryLinks]="true" (pageChange)="employeeSearch($event)">
                        </ngb-pagination>
                    </div>
                </div>

            </div>
        </div>
    </fieldset>
</div>